(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get product data
    const product = JSON.parse(section.querySelector(".productV1JSON").textContent);

    // note, the starting activeVariant is set in the section liquid file, when options are changed we fetch the new variant data from the server
    let activeVariant = JSON.parse(section.querySelector(".productV1VariantJSON").textContent);
    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

    const productSwiper = new Swiper(section.querySelector(".productV1VisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoHeight: true,
        on: {
            slideChange: function () {
                if (!section.querySelector(".productV1VisualSwiperSlide")) {
                    return;
                }

                // pause all videos
                section.querySelectorAll(".productV1VisualSwiperSlide video").forEach(element => {
                    element.pause();
                });
            }
        }
    });

    // play video on slide play click
    section.querySelectorAll(".productV1VisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productV1VisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productV1VisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    /**************
     Update Product
     ***************/

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", () => updateProduct().catch(e => console.error(e)));
    })

    // clicking option selling option box will switch plan
    section.querySelectorAll('.productV1SellingOption')?.forEach(el => {
        el.addEventListener('click', function () {
            // update status and ensure the product updates
            this.querySelector('.productV1SellingOptionHeaderInput').checked = true;
            this.querySelector('.productV1SellingOptionHeaderInput').dispatchEvent(new Event('change'));
        })
    })

    function isSubscription() {
        return !!section.querySelector(`.productV1SellingOptionHeaderInput[value="sub"]:checked`);
    }

    function currentSellingPlan() {
        return parseInt(section.querySelector('.productV1SellingOptionPlansItemInput:checked')?.value) || null;
    }

    // select every month if available for selling plans
    if (section.querySelector('.productV1SellingOptionPlansItemInput[value="2555871367"]')) {
        section.querySelector('.productV1SellingOptionPlansItemInput[value="2555871367"]').checked = true;
        section.querySelector('.productV1SellingOptionPlansItemInput[value="2555871367"]').dispatchEvent(new Event('change'));
    }

    // capture text for button - allows custom button text
    const available = section.querySelector('.productV1ATC')?.dataset?.text.split(":")[0] || "Add to Cart";
    const soldOut = section.querySelector('.productV1ATC')?.dataset?.text.split(":")[1] || "Sold Out";

    async function updateProduct() {

        // find active variant
        activeVariant = await getActiveVariant();

        // check if variant wasn't found (null would be returned from the fetch)
        if (!activeVariant) {
            section.querySelector(".productV1ATC").disabled = true;
            section.querySelector(".productV1ATC").textContent = "Not Available";
            return;
        }

        /*******************
         Dynamic Shop Button
         ********************/

        // update dynamic button inputs
        if (section.querySelector('.productV1Form')) {
            section.querySelector('.productV1FormVariant').value = activeVariant.id;
            section.querySelector('.productV1FormQuantityInput').value = quantity;
            section.querySelector('.productV1FormSellingInput').value = isSubscription() ? currentSellingPlan() : "";
        }

        /**************
         Option labels
         ***************/

        // add the active value to each option label
        section.querySelectorAll(".productV1OptionsItem").forEach(item => {
            item.querySelector(".productV1OptionsItemLabelActive").textContent =
                item.querySelector('.productV1OptionsItemValuesLabelInput:checked')?.dataset?.label || item.querySelector('.productV1OptionsItemValuesLabelInput:checked').value;
        })

        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        /**************
         Price
         ***************/

        // if there's a subscription we need to update both prices
        if (product.selling_plan_groups.length > 0) {
            // Select both sets of elements at once
            const compares = section.querySelectorAll(".productV1SellingOptionHeaderPriceCompare");
            const reals = section.querySelectorAll(".productV1SellingOptionHeaderPriceReal");

            // Destructure them for clarity:
            // Assuming the markup is structured so that index 0 is for subscription, index 1 for one-time purchase
            const [subCompare, oneTimeCompare] = compares;
            const [subReal, oneTimeReal] = reals;

            const allocationPrice = activeVariant.selling_plan_allocations[0].price;

            // Update subscription prices in buy box
            subCompare.textContent = activeVariant.price > allocationPrice ? price(activeVariant.price) : "";
            subReal.textContent = price(allocationPrice);

            // Update one-time purchase prices
            oneTimeCompare.textContent = activeVariant.compare_at_price > activeVariant.price ? price(activeVariant.compare_at_price) : "";
            oneTimeReal.textContent = price(activeVariant.price);

            // Update main price above the buy box
            if (isSubscription()) {
                section.querySelector(".productV1PriceCompare").textContent = activeVariant.price > allocationPrice ? price(activeVariant.price) : "";
                section.querySelector(".productV1PriceActual").textContent = price(allocationPrice);
            } else {
                section.querySelector(".productV1PriceCompare").textContent = activeVariant.compare_at_price > activeVariant.price ? price(activeVariant.compare_at_price) : "";
                section.querySelector(".productV1PriceActual").textContent = price(activeVariant.price);
            }

        } else {
            // Non-subscription scenario - no buy box
            section.querySelector(".productV1PriceCompare").textContent = activeVariant.compare_at_price > activeVariant.price ? price(activeVariant.compare_at_price) : "";
            section.querySelector(".productV1PriceActual").textContent = price(activeVariant.price);
        }

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productV1ATC").disabled = false;
            section.querySelector(".productV1ATC").textContent = available;
        } else {
            section.querySelector(".productV1ATC").disabled = true;
            section.querySelector(".productV1ATC").textContent = soldOut;
        }

        // check for gift/s
        markGifts();

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct().catch(e => console.error(e));

    /**
     * Fetches the active variant based on the selected options.
     * If there are more than 250 variants, it makes a request to the server to fetch the active variant since Shopify's storefront API has a limit of 250 variants per product.
     * @returns {Promise<Object>} The active variant object
     */
    async function getActiveVariant() {
        // Fetch variant when exceeding Shopify's 250 variant limit
        if (product.variants.length >= 250) {
            const optionIDs = [];
            section.querySelectorAll(".productV1OptionsItemValuesLabelInput:checked").forEach(element => {
                optionIDs.push(element.dataset.id);
            });
            const response = await fetch(`${window.location.pathname}?view=active-variant&option_values=${optionIDs.join(',')}`)
                .then(response => response.json());
            return response.active_variant;
        }

        // If there's only one variant, return it immediately
        if (product.variants.length === 1) {
            return product.variants[0];
        }

        // Gather selected values
        const options = [];
        section.querySelectorAll('.productV1OptionsItem').forEach(group => {
            options.push(group.querySelector('input:checked').value);
        });

        // Find matching variant and return it
        return product.variants.find(variant =>
            JSON.stringify(variant.options) === JSON.stringify(options)
        );
    }

    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelector(".productV1QuantityBtn.minus")?.addEventListener("click", async function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelector(".productV1QuantityValue").textContent = quantity;
        await updateProduct().catch(e => console.error(e));
    });

    // plus
    section.querySelector(".productV1QuantityBtn.plus")?.addEventListener("click", async function () {
        quantity++;
        section.querySelector(".productV1QuantityValue").textContent = quantity;
        await updateProduct().catch(e => console.error(e));
    });

    // update product on input change
    section.querySelectorAll(".productV1OptionsItemValuesLabelInput").forEach(function (element) {
        element.addEventListener("change", async function () {
            await updateProduct().catch(e => console.error(e));
        });
    });

    /**************
     Gifts section
     ***************/

    async function markGifts() {
        // check threshold of gifts and quantity. Mark as active or not and change text
        section.querySelectorAll(".productV1GiftsItem")?.forEach(item => {
            const hitThreshold = quantity >= parseInt(item.dataset.threshold);
            hitThreshold ? item.classList.add("active") : item.classList.remove("active");
            // update the text if threshold reached, else revert
            section.querySelector(".productV1GiftsHeaderText").textContent =
                hitThreshold ? item.dataset.message : section.querySelector('.productV1GiftsHeaderText').dataset.text;
        })
    }

    /**********************
     Informational dropdowns
     ***********************/

    section.querySelectorAll(".productV1DropsItemTrigger")?.forEach(trig => {
        trig.addEventListener("click", function () {
            if (this.classList.contains("active")) {
                this.classList.remove("active")
                this.setAttribute("aria-expanded", "false");
                return;
            }
            section.querySelectorAll(".productV1DropsItemTrigger").forEach(el => {
                el === this ? el.classList.add("active") : el.classList.remove("active");
                el === this ? el.setAttribute("aria-expanded", "true") : el.setAttribute("aria-expanded", "false");
            })
        })
    })

    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productV1ATC").classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (isSubscription()) {
            formData.items[0].selling_plan = currentSellingPlan();
        }

        // update the status of gifts
        await markGifts()
        // add any gifts marked
        section.querySelectorAll(".productV1GiftsItem.active")?.forEach(item => {
            const giftId = parseInt(item.dataset.gift)
            // check if gift is in the cart, add to form if not
            if (!cart.items.find(item => item.variant_id === giftId)) {
                formData.items.push({
                    quantity: 1,
                    id: giftId,
                    properties: {
                        _gift: "true"
                    }
                })
            }
        })

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productV1ATC").classList.remove("loading");

        // open cart
        await openCart();
    }

    section.querySelector('.productV1ATC').addEventListener("click", addToCart);
}());